import React from 'react';
import { Field } from 'react-final-form';
import CustomInputField from '../../../../components/form/CustomInputField';
import CustomSelect from '../../../../components/form/CustomSelect';
import CustomRadioButton from '../../../../components/form/CustomRadioButton';
import { useDict } from '../../../../contexts/LanguageContext';

const StudentSelected = ({
    submitted,
    employedStudent,
    sourceOfWealth,
    jobCategory,
    title,
    netWorth,
    annualIncome,
}) => {
    const dict = useDict();

    return (
        <span style={{ width: '100%' }}>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.sourceOfWealth}:
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap">
                        <Field name="source_of_wealth">
                            {({ input, meta }) => (
                                <CustomSelect
                                    input={input}
                                    meta={meta}
                                    options={sourceOfWealth}
                                    placeholder={dict.selectSourceOfWealth}
                                    submitted={submitted}
                                    data-cy="wealthDeclaration__sourceOfWealth"
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.annualIncome}:
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap" data-private>
                        <Field name="annual_income">
                            {({ input, meta }) => (
                                <CustomSelect
                                    input={input}
                                    meta={meta}
                                    options={annualIncome}
                                    placeholder={dict.selectAnnualIncome}
                                    submitted={submitted}
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.netWorth}:
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap" data-private>
                        <Field name="networth_id">
                            {({ input, meta }) => (
                                <CustomSelect
                                    input={input}
                                    meta={meta}
                                    options={netWorth}
                                    placeholder={dict.selectNetWorth}
                                    submitted={submitted}
                                    data-cy="wealthDeclaration__netWorth"
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.isEmployedPreviously}
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap">
                        <Field name="employedPrevious" type="radio" value="1">
                            {({ input, meta }) => (
                                <CustomRadioButton
                                    input={input}
                                    meta={meta}
                                    label={dict.yes}
                                    className="colored"
                                    submit={submitted}
                                />
                            )}
                        </Field>
                        <Field name="employedPrevious" type="radio" value="0">
                            {({ input, meta }) => (
                                <CustomRadioButton
                                    input={input}
                                    meta={meta}
                                    label={dict.no}
                                    className="colored"
                                    submit={submitted}
                                    // defaultChecked
                                    data-cy="employedPrevious__radio"
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>

            <div
                className="form__form-group"
                style={{ display: employedStudent ? '' : 'none' }}
            >
                <span className="form__form-group-label">
                    {dict.previousCompanyName}:
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap" data-private>
                        <Field name="company_name">
                            {({ input, meta }) => (
                                <CustomInputField
                                    input={input}
                                    meta={meta}
                                    submitted={submitted}
                                    style={{}}
                                    type="text"
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
            <div
                className="form__form-group"
                style={{ display: employedStudent ? '' : 'none' }}
            >
                <span className="form__form-group-label">
                    {dict.previousJobCategory}:
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap">
                        <Field name="job_category_id">
                            {({ input, meta }) => (
                                <CustomSelect
                                    input={input}
                                    meta={meta}
                                    options={jobCategory}
                                    placeholder={dict.selectJobCategory}
                                    submitted={submitted}
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
        </span>
    );
};

StudentSelected.defaultProps = {
    submitted: false,
    employedStudent: false,
    sourceOfWealth: [],
    jobCategory: [],
    title: [],
    netWorth: [],
};

export default StudentSelected;
